import React from 'react'
import { Paper, Typography, Chip, IconButton } from '@material-ui/core'
import { Edit as EditIcon, Delete as DeleteIcon, CameraAlt, HelpOutline } from '@material-ui/icons'

const AreaCard = ({ area, selected, photoCount, unresolvedQuestions, onSelect, onEdit, onDelete }) => {
  const [hovered, setHovered] = React.useState(false)

  return (
    <Paper
      elevation={selected ? 3 : 1}
      onClick={() => onSelect(area._id)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: '10px 12px', cursor: 'pointer', marginBottom: 6,
        borderLeft: selected ? '3px solid #2e7d32' : '3px solid transparent'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <Typography variant="body2" style={{ fontWeight: 600, fontSize: 13 }}>{area.name}</Typography>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 2 }}>
            {area.phase && <Chip size="small" label={area.phase} style={{ height: 18, fontSize: 10 }} />}
            {photoCount > 0 && (
              <span style={{ display: 'flex', alignItems: 'center', gap: 2, fontSize: 11, color: '#666' }}>
                <CameraAlt style={{ fontSize: 14 }} /> {photoCount}
              </span>
            )}
            {unresolvedQuestions > 0 && (
              <span style={{ display: 'flex', alignItems: 'center', gap: 2, fontSize: 11, color: '#ff9800' }}>
                <HelpOutline style={{ fontSize: 14 }} /> {unresolvedQuestions}
              </span>
            )}
          </div>
        </div>
        {hovered && (
          <div>
            <IconButton size="small" onClick={(e) => { e.stopPropagation(); onEdit(area) }}>
              <EditIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={(e) => { e.stopPropagation(); onDelete(area) }}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </div>
        )}
      </div>
    </Paper>
  )
}

export default AreaCard
